document.addEventListener('DOMContentLoaded', function() {
  const filterContainer = document.querySelector('.help-center-retailers__filters--inner');
  
  if (filterContainer) {
    const filterButtons = filterContainer.querySelectorAll('.help-center-retailers__filters__filter');
    const retailerBlocks = document.querySelectorAll('.help-center-retailers__block');
    
    filterButtons.forEach((button) => {
      button.addEventListener('click', function() {
        /** Remove active class from all buttons **/
        filterButtons.forEach((btn) => {
          btn.classList.remove('help-center-retailers__filters__filter--active');
        });
        
        /** Add active class to clicked button **/
        this.classList.add('help-center-retailers__filters__filter--active');
        
        /** Filter retailer blocks based on location **/
        const selectedLocation = this.querySelector('.help-center-retailers__filters__filter--text').textContent.trim().toLowerCase();
        
        retailerBlocks.forEach((block) => {
          const blockLocation = block.dataset.location ? block.dataset.location.toLowerCase() : '';
          
          if (selectedLocation === 'all' || selectedLocation === blockLocation) {
            block.style.display = 'flex';
          } else {
            block.style.display = 'none';
          }
        });
      });
    });
    
    /** Initialize with the filter that has the active class **/
    const activeFilter = filterContainer.querySelector('.help-center-retailers__filters__filter--active');
    if (activeFilter) {
      const initialLocation = activeFilter.querySelector('.help-center-retailers__filters__filter--text').textContent.trim().toLowerCase();
      
      retailerBlocks.forEach((block) => {
        const blockLocation = block.dataset.location ? block.dataset.location.toLowerCase() : '';
        
        if (initialLocation === 'all' || initialLocation === blockLocation) {
          block.style.display = 'flex';
        } else {
          block.style.display = 'none';
        }
      });
    }
  }
});
